import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./Toolbar.module.css";

export interface ToolbarProps {
  /** Search, filters and view options, in that order. */
  children?: ReactNode;
  /** Actions pushed to the end of the row (export, column settings). */
  end?: ReactNode;
  /** Names the controls for assistive technology ("Filter lots"). */
  label?: string;
  className?: string;
}

/**
 * The row between PageHeader and content. A layout container rather than an ARIA toolbar:
 * filter rows mix text fields and selects, which arrow-key roving focus would get in the way of.
 */
export function Toolbar({ children, end, label, className }: ToolbarProps) {
  return (
    <div className={clsx(styles.toolbar, className)} role={label ? "group" : undefined} aria-label={label}>
      <div className={styles.start}>{children}</div>
      {end ? <div className={styles.end}>{end}</div> : null}
    </div>
  );
}
